import { render, staticRenderFns } from "./PixBilling.vue?vue&type=template&id=ac21f764&"
import script from "./PixBilling.vue?vue&type=script&lang=js&"
export * from "./PixBilling.vue?vue&type=script&lang=js&"
import style0 from "./PixBilling.vue?vue&type=style&index=0&id=ac21f764&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports